import { Link } from "react-router-dom";

export const Footer = () => (
  <footer className="border-t border-slate-200 bg-[#EDF4FB] py-14" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="flex flex-col md:flex-row md:items-start justify-between gap-10">
        <div className="max-w-sm">
          <img
            src="/logo-full.png"
            alt="OPERA360 — The Operating System for Property Performance"
            className="h-40 w-auto rounded-md bg-white p-3"
            data-testid="footer-logo"
          />
          <p className="mt-5 text-sm text-muted-foreground leading-relaxed">
            Your property-management software tracks the property. OPERA360 develops the people who operate it.
          </p>
          <p className="mt-4 text-xs font-mono uppercase tracking-[0.2em] text-muted-foreground/60">
            Train · Walk · Audit
          </p>
        </div>
        <div className="flex gap-16">
          <div>
            <p className="text-xs font-mono uppercase tracking-widest text-muted-foreground/60 mb-4">Platform</p>
            <ul className="space-y-2.5 text-sm">
              <li><a href="#platform" className="text-muted-foreground hover:text-slate-900 transition-colors">The 3 Modules</a></li>
              <li><a href="#intelligence" className="text-muted-foreground hover:text-slate-900 transition-colors">Intelligence</a></li>
              <li><a href="#pricing" className="text-muted-foreground hover:text-slate-900 transition-colors">Pricing</a></li>
              <li><Link to="/certification" className="text-muted-foreground hover:text-slate-900 transition-colors">Certification</Link></li>
            </ul>
          </div>
          <div>
            <p className="text-xs font-mono uppercase tracking-widest text-muted-foreground/60 mb-4">Company</p>
            <ul className="space-y-2.5 text-sm">
              <li><a href="#demo" className="text-muted-foreground hover:text-slate-900 transition-colors">Book a Demo</a></li>
              <li>
                <Link to="/login" data-testid="footer-admin-link" className="text-muted-foreground hover:text-sky-600 transition-colors">
                  Admin CRM
                </Link>
              </li>
              <li>
                <Link to="/training" data-testid="footer-training-link" className="text-muted-foreground hover:text-sky-600 transition-colors">
                  Team Training Sign In
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="mt-12 pt-6 border-t border-white/[0.06] flex flex-col sm:flex-row justify-between gap-3 text-[11px] font-mono uppercase tracking-wider text-muted-foreground/50">
        <span>© {new Date().getFullYear()} OPERA360 — The Operating System for Property Performance</span>
        <span>Manufactured Housing · Multifamily · RV · SFR · Self Storage · HOA</span>
      </div>
    </div>
  </footer>
);
